interface PendingNewPasswordChallengeState {
    readonly emailAddress: string;
    readonly primaryWorkyCorpId: string | null;
}

enum CognitoNewPasswordChallengeStep {
    CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED = 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
}

export type { PendingNewPasswordChallengeState };
export { CognitoNewPasswordChallengeStep };
